import { getUriNamespaceMetadataFromConstructor } from './entity-uri';
export const isEntityUri = (Clazz, uri) => {
    const namespaces = getUriNamespaceMetadataFromConstructor(Clazz);
    return !!namespaces.find((namespace) => (uri || '').startsWith(`${namespace}:`));
};
//# sourceMappingURL=is-entity-uri.js.map